// Mock data for Brand Marketing Professionals - ORM & Review Management

export const brand = {
  name: "Brand Marketing Professionals",
  short: "BMP",
  tagline: "We remove defamatory reviews or you don't pay.",
  email: "brandmarketingprofessionals@gmail.com",
  phones: ["+65 3158 1168", "+91 9650 881321"],
  whatsapp: "https://web.whatsapp.com/send?phone=919650881321&text=",
};

export const stats = [
  { number: "5,000+", label: "Brands served worldwide" },
  { number: "~14 days", label: "Average removal time" },
  { number: "+1.5", label: "Average rating increase" },
  { number: "22+", label: "Years in the industry" },
];

export const heroBadges = [
  "No removal, no fee guarantee",
  "5.0 ★ on Google (100+ reviews)",
  "Trusted by 5,000+ brands",
];

export const pressLogos = [
  { name: "Forbes" },
  { name: "Yahoo Finance" },
  { name: "Business Insider" },
  { name: "AP News" },
  { name: "CBS" },
  { name: "Clutch" },
];

export const whyUs = [
  {
    title: "No upfront fees",
    desc: "You pay only for successful removals. If we can't remove your content, you owe us nothing. No retainers, no subscriptions, no surprises.",
    icon: "ShieldCheck",
  },
  {
    title: "Removed in ~14 days",
    desc: "Most content is taken down within two weeks. We handle the platform policies, applications and follow-through so you don't have to.",
    icon: "Clock",
  },
  {
    title: "Proven specialists",
    desc: "Our team has removed content for more than 5,000 brands worldwide. We use legitimate, policy-based methods, never shady tactics.",
    icon: "Award",
  },
];

export const platforms = [
  { name: "Google", sub: "Business Profile reviews", initials: "G" },
  { name: "Facebook", sub: "Pages & reviews", initials: "F" },
  { name: "Glassdoor", sub: "Employer reviews", initials: "GD" },
  { name: "Indeed", sub: "Company reviews", initials: "IN" },
  { name: "Avvo", sub: "Attorney reviews", initials: "A" },
  { name: "Reddit", sub: "Posts & threads", initials: "R" },
  { name: "RateMDs", sub: "Doctor reviews", initials: "RM" },
  { name: "Trustpilot", sub: "Business reviews", initials: "TP" },
];

export const steps = [
  { n: 1, title: "Submit your content", desc: "Send us links to the reviews or posts hurting you. We'll assess them free of charge, no obligation." },
  { n: 2, title: "Research & analysis", desc: "Our specialists review each item against the platform's policies and build the strongest possible case for removal." },
  { n: 3, title: "We submit for removal", desc: "We handle the formal applications and every follow-up with the platform on your behalf, start to finish." },
  { n: 4, title: "Content removed", desc: "The content comes down and we confirm it with you. Only then do you pay for what we removed." },
];

export const compare = {
  others: [
    "Charge large fees upfront, with no guarantee of results",
    "Rely on outdated \"suppression\" tactics that bury, not remove",
    "Lock you into subscriptions, retainers and hidden costs",
    "Push expensive legal or litigation options",
    "Over-promise and under-deliver",
  ],
  us: [
    "Pay only for successful removals, never upfront",
    "Content is removed at the source, not just buried",
    "Clear, one-time pricing with no hidden fees",
    "Legitimate, policy-based methods that protect you",
    "Results in ~14 days, backed by 5,000+ brands served",
  ],
};

export const testimonials = [
  {
    name: "Joe Tekulve",
    role: "Business owner",
    initials: "JT",
    text: "An unfair one-star review was tanking our rating. Brand Marketing Professionals had it removed within just a few days. Couldn't believe how simple it was.",
  },
  {
    name: "Gabriel Pimentel",
    role: "Clinic director",
    initials: "GP",
    text: "We'd tried two other agencies with no luck. Their team removed the defamatory review in 72 hours. Wish we'd found them first.",
  },
  {
    name: "John Waldron",
    role: "Managing partner",
    initials: "JW",
    text: "Exactly what they promised, and months later the review is still gone. No upfront cost meant there was genuinely no risk in trying.",
  },
  {
    name: "Sarah Gore",
    role: "Marketing lead",
    initials: "SG",
    text: "Their reputation team is sharp, responsive, and results-driven. Our rating jumped from 3.4 to 4.7 within a quarter.",
  },
];

export const faqs = [
  {
    q: "What does \"no removal, no fee\" actually mean?",
    a: "It means exactly what it says. We assess your content for free and only charge you once it has been successfully removed. If we can't remove it, you pay nothing. There are no upfront fees, retainers or subscriptions.",
  },
  {
    q: "How long does removal take?",
    a: "Most content is removed within about 14 days, and some cases resolve in as little as 72 hours. Timelines vary by platform and the complexity of the case, and we'll keep you updated throughout.",
  },
  {
    q: "What kind of content can you remove?",
    a: "We specialise in defamatory, fake and policy-violating reviews and posts across Google, Facebook, Glassdoor, Indeed, Avvo, Reddit, RateMDs, Trustpilot and many more. If you're unsure whether your content qualifies, submit it for a free assessment and we'll let you know.",
  },
  {
    q: "Are your methods safe and legitimate?",
    a: "Yes. We use legitimate, policy-based methods that work within each platform's terms of service. We never contact reviewers directly or use tactics that could put your business at risk.",
  },
  {
    q: "Will the content stay removed?",
    a: "In the vast majority of cases, yes. Because the content is removed at the source rather than hidden or suppressed, it rarely comes back. If a platform does reinstate content, we'll let you know your options for getting it removed again.",
  },
];

export const services = [
  {
    slug: "online-reputation-management",
    title: "Online Reputation Management",
    tagline: "Own your narrative across search and social.",
    desc: "Build, protect and defend your brand's digital reputation with a proactive strategy tailored to your industry.",
    features: [
      "Search result cleanup & suppression of negative pages",
      "Brand sentiment tracking across the web",
      "Executive & personal reputation programs",
      "Crisis response & PR containment",
    ],
    icon: "ShieldCheck",
  },
  {
    slug: "review-management",
    title: "Review Management",
    tagline: "Turn your reviews into a growth engine.",
    desc: "Generate authentic 5-star reviews, respond professionally and lift your average rating across every important platform.",
    features: [
      "Automated review invitations & follow-ups",
      "Professionally written review responses",
      "Rating recovery playbooks",
      "Multi-location dashboards & reporting",
    ],
    icon: "Star",
  },
  {
    slug: "content-removal",
    title: "Content Removal",
    tagline: "Defamatory content gone at the source.",
    desc: "We remove unfair reviews, malicious posts and defamatory content from the platforms that matter to your business. No removal, no fee.",
    features: [
      "Google, Facebook, Glassdoor, Indeed removals",
      "Reddit, Trustpilot, RateMDs & niche platforms",
      "News articles & search result de-indexing",
      "Policy-based, safe, legitimate methods",
    ],
    icon: "Trash2",
  },
  {
    slug: "reputation-monitoring",
    title: "Reputation Monitoring",
    tagline: "Know what's said, the moment it's said.",
    desc: "24/7 monitoring across reviews, news, forums and social channels with real-time alerts for anything that could harm your brand.",
    features: [
      "Real-time review & mention alerts",
      "Sentiment analysis dashboards",
      "Competitor benchmarking",
      "Monthly executive reports",
    ],
    icon: "Radar",
  },
];

export const pricing = [
  {
    name: "Starter",
    price: "$299",
    period: "/month",
    desc: "For small businesses building their online reputation.",
    features: [
      "Up to 3 platforms monitored",
      "Review invitations (up to 250/mo)",
      "Monthly reputation report",
      "Email support",
    ],
    popular: false,
    cta: "Get started",
  },
  {
    name: "Growth",
    price: "$799",
    period: "/month",
    desc: "For growing brands that need proactive review management.",
    features: [
      "Up to 10 platforms monitored",
      "Unlimited review invitations",
      "Response-writing service",
      "Weekly reports & dashboards",
      "Dedicated account manager",
    ],
    popular: true,
    cta: "Start growth plan",
  },
  {
    name: "Enterprise",
    price: "Custom",
    period: "",
    desc: "For multi-location brands, franchises & agencies.",
    features: [
      "Unlimited platforms & locations",
      "Full-service content removal",
      "Crisis response team",
      "Custom integrations & API",
      "Executive reputation programs",
    ],
    popular: false,
    cta: "Talk to sales",
  },
];

export const removalPricing = {
  headline: "Content removal · pay only for results",
  sub: "Transparent one-time pricing. No removal, no fee.",
  rows: [
    { platform: "Google Reviews", price: "from $499" },
    { platform: "Facebook Reviews", price: "from $549" },
    { platform: "Glassdoor Reviews", price: "from $699" },
    { platform: "Indeed Reviews", price: "from $649" },
    { platform: "Reddit Posts", price: "from $749" },
    { platform: "Trustpilot Reviews", price: "from $599" },
  ],
};

export const timelineAbout = [
  { year: "2003", title: "Founded", desc: "Started as a boutique digital marketing agency in India." },
  { year: "2012", title: "Global expansion", desc: "Opened offices in Singapore, UAE and the USA." },
  { year: "2019", title: "ORM division", desc: "Launched a dedicated Online Reputation Management practice." },
  { year: "2025", title: "5,000+ brands served", desc: "Trusted by law firms, clinics, hotels and Fortune-500 vendors worldwide." },
];

export const offices = [
  { country: "India", address: "Unit UGF001, FBDONE Corporate Park, NH-44, Faridabad, Haryana – 121003" },
  { country: "UAE", address: "M 43, Musaffah Industrial Area, Bin Doza Street-2, Plot 50, Abu Dhabi" },
  { country: "Singapore", address: "112 Cecil St, #07-01 The Octagon, Singapore 069534" },
  { country: "USA", address: "5722 Spry Cmn, Fremont, CA 94538" },
];
